/* eslint-disable max-len */
import * as React from 'react'
const NumberSvg = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" {...props}>
    <path
      fill="#191919"
      fillRule="nonzero"
      d="M33.87 35.88a15.295 15.295 0 0 1-17.037 3.323 4.486 4.486 0 0 0-2.74-4.969 4.526 4.526 0 0 0-5.446 1.657 4.474 4.474 0 0 0 .522 5.644 4.53 4.53 0 0 0 5.66.64c7.593 3.612 16.674 1.746 22.208-4.564a8.561 8.561 0 0 1-3.167-1.732ZM18.427 4c-2.375-.007-4.348 1.82-4.51 4.178C5.108 13.05 1.557 23.85 5.766 32.961a8.588 8.588 0 0 1 2.893-2.157c-2.9-7.13-.151-15.299 6.477-19.255a4.523 4.523 0 0 0 5.456.867 4.475 4.475 0 0 0 2.2-5.044A4.502 4.502 0 0 0 18.426 4Zm23.42 21.605c0-.226.02-.452.02-.665.038-9.052-6.345-16.874-15.256-18.696.386 1.195.5 2.461.334 3.706 6.76 1.873 11.431 8.008 11.414 14.99v.147a4.49 4.49 0 0 0-3.373 4.58 4.496 4.496 0 0 0 3.837 4.202 4.512 4.512 0 0 0 4.904-2.903 4.476 4.476 0 0 0-1.88-5.36Z"
    />
  </svg>
)
export default NumberSvg
